import React from "react";
import { useState, useEffect } from "react";
import leftTree from "../../assets/images/left-tree.png";
import righttree from "../../assets/images/right-tree.png";
import Slider from "react-slick";
import Img1 from "../../assets/images/Dry_fruits.jpg";
import { fetchQuickLinks } from "../../features/QuickSlice";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
function QuickLink() {
  const CustomPrevArrow = ({ onClick }) => {
    return (
      <button className="custom-prev-arrow" onClick={onClick}>
        <i className="fa-solid fa-arrow-left"></i>
      </button>
    );
  };

  const CustomNextArrow = ({ onClick }) => {
    return (
      <button className="custom-next-arrow" onClick={onClick}>
        <i className="fa-solid fa-arrow-right"></i>
      </button>
    );
  };

  const [sliderSettings, setSlidersettings] = useState({
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    margin: 8,
    nav: true,

    loop: false,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
    responsive: [
      {
        breakpoint: 767, // Below 767px
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 991, // Below 991px
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1024, // You can add more breakpoints if needed
        settings: {
          slidesToShow: 5,
        },
      },
    ],
  });

  const dispatch = useDispatch();
  const { quicklink, status, error } = useSelector((state) => state.quicklink);

  useEffect(() => {
    if (status == "idle") {
      dispatch(fetchQuickLinks());
    }
  }, [dispatch, status]);

  const quicklinkss = (item) => {
    if (item.select_type == 1) {
      if (item.category_slug && item.subcategory_slug && item.subchildcategory_slug) {
        return `/${item.category_slug}/${item.subcategory_slug}/${item.subchildcategory_slug}`;
      } else if (item.category_slug && item.subcategory_slug) {
        return `/${item.category_slug}/${item.subcategory_slug}`;
      } else if (item.category_slug) {
        return `/${item.category_slug}`;
      }
    } else if (item.select_type == 2) {
      if (item.product_slug) {
        return `/product-details/${item.product_slug}`;
      }
    } else if (item.select_type == 3) {
      if (item.classification_slug) {
        return `/classification_list/${item.classification_slug}`;
      }
    }
  };

  return (
    <>
      {quicklink && quicklink.length > 0 ? (
        <section className="quicklink_section pt-40 pb-40">
          <div className="container">
            <div className="row" style={{ justifyContent: "center" }}>
              <div className="col-xl-5 col-lg-5 col-lg-4 main-heading-inner-box">
                <div className="inner-box">
                  <img
                    src={leftTree}
                    alt="img"
                    className="heading-left-image"
                  />
                  <h3 className="main-heading-1">Quick Links</h3>
                  <img
                    src={righttree}
                    alt="img"
                    className="heading-right-image"
                  />
                </div>
              </div>
            </div>

            {quicklink.length > 3 ? (
              <div className="row second_row mt-4">
                <Slider {...sliderSettings}>
                  {quicklink.map((item, index) => (
                    <div className="inner_box_main" key={index}>
                      <div className="inner-box">
                        <div className="img_box">
                          <Link to={quicklinkss(item)}>
                            <img src={item.image} alt="img" />
                          </Link>
                        </div>
                        <div className="content_box">
                          <h6 className="text-center mt-2">{item.title}</h6>
                        </div>
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>
            ) : (
              <div className="row second_row mt-4 justify-content-center">
                {quicklink.map((item, index) => (
                  <div className="col-lg-3 col-md-3 col-sm-6" key={index}>
                    <div className="inner-box">
                      <div className="img_box">
                        <Link to={quicklinkss(item)}>
                          <img src={item.image} alt="img" />
                        </Link>
                      </div>
                      <div className="content_box">
                        <h6 className="text-center mt-2">{item.title}</h6>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </section>
      ) : null}
    </>
  );
}

export default QuickLink;
